import { useQuery } from '@tanstack/react-query'

import { CadenceContact, fetchCadenceContactsByAccount } from 'api/EmailAutomationAPI'
import { ActivityEndUser } from 'modules/accountActivity/domain'
import { DateRange } from 'pages/EmailDashboard/utils'

export const useCadenceContacts = (
  accountId: string,
  dateRange: DateRange
): {
  data: ActivityEndUser[] | undefined
  error: Error | null
  isLoading: boolean
} => {
  const { data, error, isLoading: isLoadingCadenceContacts } = useQuery<ActivityEndUser[], Error>({
    queryKey: ['fetchCadenceContacts', dateRange.startTime, dateRange.endTime, accountId],
    queryFn: () =>
      fetchCadenceContactsByAccount(accountId, dateRange.startTime, dateRange.endTime).then(res => {
        return res.data.map((user: CadenceContact) => user.endUserData)
      }),
    staleTime: 1000 * 60
  })

  return {
    data,
    error,
    isLoading: isLoadingCadenceContacts
  }
}
